import { createContext } from 'react';

import { AnyDependenciesDefinition } from '../../../formBuilder/types';

export const DependenciesContext = createContext<AnyDependenciesDefinition>({});
